export default __webpack_public_path__ + "static/media/8.f7e9bc0f.jpg";